// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__--7GY","item":"Footer_item__MgC9p","item__text":"Footer_item__text__feSSX"};